import React from 'react'

export default function SelectGroup(props) {
	return (
		<div className="selectgroup">
			<label
				className={props.className ? 'selectgroup-item ' + props.className : 'selectgroup-item'}
				style={props.style}>
				<input
					checked={props.active === props.value1 ? true : false}
					className="selectgroup-input"
					id={props.id}
					name={props.id}
					type="radio"
					onChange={props.onChange}
					value={props.value1}
				/>
				<span className="selectgroup-button" style={props.style}>
					{props.text1}
				</span>
			</label>
			<label
				className={props.className ? 'selectgroup-item ' + props.className : 'selectgroup-item'}
				style={props.style}>
				<input
					checked={props.active === props.value2 ? true : false}
					className="selectgroup-input"
					id={props.id}
					name={props.id}
					type="radio"
					onChange={props.onChange}
					value={props.value2}
				/>
				<span className="selectgroup-button" style={props.style}>
					{props.text2}
				</span>
			</label>
			{props.text3 && (
				<label
					className={props.className ? 'selectgroup-item ' + props.className : 'selectgroup-item'}
					style={props.style}>
					<input
						checked={props.active === props.value3 ? true : false}
						className="selectgroup-input"
						id={props.id}
						name={props.id}
						type="radio"
						onChange={props.onChange}
						value={props.value3}
					/>
					<span className="selectgroup-button" style={props.style}>
						{props.text3}
					</span>
				</label>
			)}
		</div>
	)
}
